import React, { Component } from 'react';
import * as styled from './grid.styled';
import { DEBUG_MODE } from '../../constants/configs';

class Grid extends Component {

    constructor() {
        super();
    }

    componentDidCatch(){}

    render() {
        if (!DEBUG_MODE) return null;
        return (
            <React.Fragment>
                <styled.Frame>
                    <div></div>
                </styled.Frame>
                <styled.Grid>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </styled.Grid>
            </React.Fragment>
        );
    }
}

export default Grid;